export var Timing;
(function (Timing) {
    Timing["afterWebAllowlisting"] = "after_web_allowlisting";
    Timing["immediate"] = "immediate";
    Timing["revisitWebAllowlisted"] = "revisit_web_allowlisted_site";
    Timing["afterNavigation"] = "after_navigation";
})(Timing || (Timing = {}));
